import type { StoreSlice, WarrantyActions, WarrantyState } from '../types'

export const createWarrantySlice: StoreSlice<
  WarrantyState & WarrantyActions
> = set => ({
  // State
  useBrandWarranty: false,
  rulesToBeApplied: undefined,

  // Actions
  setUseBrandWarranty: val =>
    set({ useBrandWarranty: val }, false, 'setUseBrandWarranty'),

  setRulesToBeApplied: val =>
    set({ rulesToBeApplied: val }, false, 'setRulesToBeApplied')
})
